module.exports = __webpack_public_path__ + "img/ticket-2-line.2c24e0f4.svg";